module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/babel-runtime/core-js/array/from.js
// module id = 834
// module chunks = 0